import styles from "./reports.module.css";
import { useRef, useEffect, useState, useContext } from "react";
import { ToastService, ToastComponent } from "services/toast.service";
import { useTranslation } from "react-i18next";
import Spinner from "components/functional/spinner";
import instance from "services/api";
import { MembershipContext } from "hoc/membership-data";
import tokenService from "services/token.service";

const Reports = () => {
  const [loading, setLoading] = useState(false);

  const membershipData = useContext(MembershipContext);
  const { teams, membership } = membershipData;
  const { first_name, last_name } = membership;

  const { t } = useTranslation();
  const textareaRef = useRef(null);

  const reportBug = async () => {
    setLoading(true);
    try {
      await instance.post("/report", {
        content: {
          bug: textareaRef.current.value,
          user: {
            id: tokenService.getUserId(),
            name: `${first_name} ${last_name}`,
          },
          organization_id: tokenService.getOrganizationId(),
          team_id: teams[0].team_id,
        },
      });

      textareaRef.current.value = "";
      ToastService.showSuccessToast(t("reports.success"));
    } catch (error) {
      console.error(error);
      ToastService.showErrorToast(t("errors.generic"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    textareaRef.current.focus();
  }, []);

  return (
    <div className="dashboard-container">
      <ToastComponent />
      <header className="mb-32">
        <h1 className="title-1">{t("navigation.item.reports")}</h1>
      </header>
      <section className={styles.wrapper}>
        <div className={styles.content}>
          <h2 className="title-2-variant">{t("reports.title")}</h2>
          <textarea
            placeholder={t("reports.placeholder")}
            className={styles.textarea}
            ref={textareaRef}
          />
          <div className={styles.actions}>
            <button
              className="btn btn--primary"
              onClick={reportBug}
              disabled={loading}
            >
              {t("actions.send")}
              {loading && <Spinner className="action-loader" />}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reports;
